module.exports = __webpack_public_path__ + "static/media/Logo.a0947101.png";